import { ComponentPropsWithoutRef, forwardRef } from 'react';
// eslint-disable-next-line no-restricted-imports
import { Link, matchPath, useLocation } from 'react-router-dom';
import cn from 'classnames';

type Props = {
  to: string;
  iconClassName?: string;
  iconSrc?: string;
} & ComponentPropsWithoutRef<'li'>;

const LNBMenuItem = forwardRef<HTMLLIElement, Props>(({ iconClassName, iconSrc, children, to, ...props }, ref) => {
  const location = useLocation();
  const isCurrentLocation = matchPath(to, location.pathname);

  return (
    <li {...props} ref={ref} className={cn({ on: isCurrentLocation })}>
      <Link to={to} className="link_snb" aria-current={isCurrentLocation ? 'page' : undefined}>
        <span
          role="img"
          className={iconClassName}
          style={{ ...(!!iconSrc && { backgroundImage: `url(${iconSrc})` }) }}
        ></span>
        {children}
      </Link>
    </li>
  );
});

LNBMenuItem.displayName = 'LNBMenuItem';

export default LNBMenuItem;
